<div class="container-options">
    <div>
        <mat-checkbox class="tv-blueish-grey-checkbox" (change)="onSelectAllChange($event)">Sélectionner Tout</mat-checkbox>
    </div>

    <div class="tv-ns-custom-horizontal-divider"></div>

    <div class="search-container">
        <div
            class="tv-round-input-extensible-no-label full-width"
            [ngClass]="{ 'fade-in-right': panelOpened, 'fade-out-left': !panelOpened }">
            <mat-form-field>
                <mat-icon matPrefix class="small-icon">search</mat-icon>
                <input matInput [formControl]="searchFormControl" [matAutocomplete]="auto" name="search" />

                <mat-autocomplete autoActiveFirstOption class="tv-custom-always-visible-scroll-bar" #auto="matAutocomplete"
                                  [displayWith]="displayItem">
                    <mat-option *ngFor="let item of filteredItemList$ | async" class="tv-ns-select-option"
                                [value]="item">
                        {{ item.name }} ({{ item.id}})
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>

    <!-- Category Items -->
    <div *ngIf="!isLoadingItemList" class="checkbox-list tv-custom-scroll-bar">
        <mat-checkbox
            class="tv-blueish-grey-checkbox"
            *ngFor="let item of filteredItemList$ | async"
            [checked]="isOptionSelected(item)"
            (change)="onOptionChange($event, item)">
            {{ item.name }} - ({{ item.id }})
        </mat-checkbox>
    </div>

    <div class="button-edit">
        <button class="tv-ns-secondary-large-button-on-light-bg" (click)="onCancelSelectClick()">Annuler</button>
        <button class="tv-ns-validation-large-button" (click)="onSaveChosenItemList()">Valider</button>
    </div>
</div>
